/**
 * sum_purchase_qty.js
 * 目的：
 * - .purchase-qty-right select / .purchase-qty-left select の数量変更時に合計・小計・購入ボタン状態を更新
 * - どちらか一方でも数値でない（未選択/不正）場合は処理を行わない（UIを更新しない & 購入不可にする）
 * - セレクトはアプリで動的生成されるため、MutationObserver + イベントデリゲーションで対応
 */
(function () {
    // 多重初期化防止
    if (window.__sumQty_inited_multi) return;
    window.__sumQty_inited_multi = true;
  
    // ---------------------------
    // ヘルパー
    // ---------------------------
    function parseIntStrict(val) {
      // そのまま数値として解釈（空/不正は NaN のままにする）
      return parseInt(val, 10);
    }
  
    function getQty(selector) {
      var el = document.querySelector(selector);
      if (!el) return NaN;               // 要素自体が無ければ NaN を返し、処理スキップ
      return parseIntStrict(el.value);    // 未選択/空/不正は NaN
    }
  
    function getPrice() {
      // 価格はテーマに合わせて取得セレクタを調整
      var el = document.querySelector('.price__regular .price-item.price-item--regular');
      if (!el) return NaN;
      var digits = el.textContent.replace(/[^\d]/g, '');
      if (!digits) return NaN;
      return parseInt(digits, 10);
    }
  
    function enableOrDisableBuyButtons(canProceed, total) {
      var wrapper = document.querySelector('.product-form__buttons');
      if (!wrapper) return;
  
      var buttons = wrapper.querySelectorAll('.product-form__submit.button');
      buttons.forEach(function (btn) {
        if (canProceed && total > 0) {
          btn.disabled = false;
          btn.setAttribute('aria-disabled', 'false');
          btn.style.cursor = '';
          btn.style.opacity = '';
          btn.style.pointerEvents = '';
        } else {
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
          // 見た目はテーマに合わせて必要なら変更
          btn.style.cursor = 'not-allowed';
          btn.style.opacity = '0.5';
          btn.style.pointerEvents = 'none';
        }
      });
    }
  
    // ---------------------------
    // 中核：更新処理
    // ---------------------------
    function updateTotals() {
      try {
        var qr = getQty('.purchase-qty-right select');
        var ql = getQty('.purchase-qty-left select');
  
        // どちらか片方でも数値でない場合は処理を行わない（UIも更新しない）
        if (isNaN(qr) || isNaN(ql)) {
          enableOrDisableBuyButtons(false, 0); // 念のため購入不可に
          // 必要であれば、表示をクリアしたい場合はここでクリア処理を追加
          // 例）.total_qty や .subtotal_price を空にする 等
          return;
        }
  
        var total = qr + ql;
  
        // 数量フィールドに反映
        var qtyInput = document.querySelector('.product-form__quantity input[type="number"]');
        if (qtyInput) qtyInput.value = total;
  
        // 合計数量の表示
        var totalEl = document.querySelector('.total_qty');
        if (totalEl) totalEl.textContent = total.toLocaleString() + '個';
  
        // 小計（価格が取得できない場合は表示更新をスキップ）
        var price = getPrice();
        if (!isNaN(price)) {
          var subTotalEl = document.querySelector('.subtotal_price');
          if (subTotalEl) subTotalEl.textContent = '¥' + (price * total).toLocaleString();
        }
  
        // 購入ボタンの状態
        enableOrDisableBuyButtons(true, total);
      } catch (e) {
        console.error('[sum_purchase_qty] updateTotals error:', e);
      }
    }
  
    // ---------------------------
    // イベント監視（委譲）
    // ---------------------------
    function onQtyChange(e) {
      if (!e.target) return;
      if (e.target.matches('.purchase-qty-right select, .purchase-qty-left select')) {
        updateTotals();
      }
    }
    document.addEventListener('change', onQtyChange, true);
    document.addEventListener('input',  onQtyChange, true); // UI によっては input の段階で反応させたい
  
    // ---------------------------
    // 出現待ち（動的生成への対応）
    // ---------------------------
    var debounceId = null;
    var activated = false;
    var mo = new MutationObserver(function () {
      if (activated) return;
      if (debounceId) cancelAnimationFrame(debounceId);
      debounceId = requestAnimationFrame(function () {
        var exists = document.querySelector('.purchase-qty-right select, .purchase-qty-left select');
        if (exists) {
          activated = true;
          updateTotals();
          mo.disconnect(); // 一度初期化できたら監視停止（負荷軽減）
        }
      });
    });
  
    function startObserverWhenReady() {
      if (document.body) {
        mo.observe(document.body, { childList: true, subtree: true });
        // 既に存在していれば即時初期化
        if (document.querySelector('.purchase-qty-right select, .purchase-qty-left select')) {
          activated = true;
          updateTotals();
          mo.disconnect();
        }
      } else {
        setTimeout(startObserverWhenReady, 50);
      }
    }
    startObserverWhenReady();
  })();